import React from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import jo from './../assest/images/navigation/jo.jpg'
import './../assest/style/Navigationbar.css'
export const Navigationbar = () => {
  return (
    <div>
      



    <Navbar collapseOnSelect expand="lg" >
      <Container>
        <Navbar.Brand href="">
      <img src={jo}/>
       
       
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mc-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/about">About us</Nav.Link>
            <Nav.Link href="/services">Services</Nav.Link>
            <Nav.Link href="/skill">Skills</Nav.Link>
            <Nav.Link href="/project">Projects</Nav.Link>

            
          </Nav>
         

          <Nav className="ms-auto">
      
          <Nav.Link href="/error404" className='phon'><span>     <i class="fa-solid fa-phone fa-lg" style={{color:"#565acf",background:"#b8b5ff",padding:"20px 10px",borderRadius:"10px"}}></i> (+963)991759647</span></Nav.Link>  
            <Nav.Link href="/contact"><button className='btnc'>Contact Us <i class="fa-solid fa-chevron-right" style={{color:"#565acf",background:"#fff",padding:"14px 14px",marginLeft:"10px",borderRadius:"10px"}}></i></button></Nav.Link> 
         

            
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>


    </div>
  )
}
